import axios from 'axios'
import Store from '../store'
import { errorHandler, successHandler } from './helpers/handler'
import adminHttp from './admin/http'
import { BASEURL } from './const'

const URL = `/announcements`

export default {
  announcement() {
    return {
      create: async (formData) => {
        const endpoint = `${URL}`
        try {
          const res = await adminHttp.post(endpoint, formData, {
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers,
              'content-type': 'multipart/form-data'
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      get: async (params = {}) => {
        const endpoint = `${URL}`
        try {
          const res = await adminHttp.get(endpoint, {
            params,
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getASingle: async ({ id, params = {} }) => {
        const endpoint = `${URL}/${id}`
        try {
          const res = await adminHttp.get(endpoint, {
            params,
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getCurrent: async (type) => {
        const endpoint = `${BASEURL}${URL}/users`
        const params = {
          active: true,
          limit: type === 'popup' ? 1 : 3,
          offset: 0
        }
        if (type) params.type = type
        try {
          const res = await axios.get(endpoint, {
            params,
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      update: async ({ id, data }) => {
        const endpoint = `${URL}/${id}`

        const formData = new FormData()
        for (const key in data) {
          formData.append(key, data[key])
        }

        try {
          const res = await adminHttp.put(endpoint, formData, {
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers,
              'content-type': 'multipart/form-data'
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      makeActive: async ({ id }) => {
        const endpoint = `${URL}/${id}`
        try {
          const res = await adminHttp.put(
            endpoint,
            { active: true },
            {
              headers: {
                ...Store.getters['admin/getRequestHeaders'].headers
              }
            }
          )
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      makeInactive: async ({ id }) => {
        const endpoint = `${URL}/${id}`
        try {
          const res = await adminHttp.put(
            endpoint,
            { active: false },
            {
              headers: {
                ...Store.getters['admin/getRequestHeaders'].headers
              }
            }
          )
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      delete: async ({ id }) => {
        const endpoint = `${URL}/${id}`
        try {
          const res = await adminHttp.delete(endpoint, {
            headers: {
              ...Store.getters['admin/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      }
    }
  }
}
